import $ from 'jquery'
import { isSP } from './checkScreen'

const $frame = $('.js-frame-left')

const randFrameBg = () => {
  const $bg = $frame.find('.box-bg')
  const max = 1840
  const randPos = Math.floor(Math.random() * (max - 0 + 1) + 0)

  $bg.css({
    backgroundPosition: `0px ${randPos * -1}px`
  })
}

const randText = () => {
  const $text = $frame.find('.box-text')

  if (!$text.length) {
    return
  }

  const max = isSP() ? 590 : 580
  const randPos = Math.floor(Math.random() * (max - 0 + 1) + 0)

  $text.css({
    top: `${randPos * -1}px`
  })
}

const frameScrolling = () => {
  $(window).on('scroll', () => {
    if (isSP()) {
      $frame.removeAttr('style')
      return
    }

    const left = $(window).scrollLeft()
    $frame.css({
      left: left * -1
    })
  })
}

const initFrameLeft = () => {
  if (!$frame.length) {
    return
  }

  randFrameBg()
  randText()
  frameScrolling()
}

export default initFrameLeft
